import { render, staticRenderFns } from "./tagAndConfigListInput.vue?vue&type=template&id=4d2d2ba3&scoped=true&"
import script from "./tagAndConfigListInput.vue?vue&type=script&lang=js&"
export * from "./tagAndConfigListInput.vue?vue&type=script&lang=js&"
import style0 from "./tagAndConfigListInput.vue?vue&type=style&index=0&id=4d2d2ba3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2d2ba3",
  null
  
)

export default component.exports